import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Stack from '@mui/material/Stack';

/** Whether a build researches each module before its outline — GEN-218, spec 018 §8. */
export function ResearchOption({
  checked,
  disabled = false,
  onChange,
}: {
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <Stack>
      <FormControlLabel
        label="Research each module first"
        control={
          <Checkbox
            checked={checked}
            disabled={disabled}
            onChange={(event) => {
              onChange(event.target.checked);
            }}
          />
        }
      />
      <FormHelperText sx={{ mt: 0 }}>
        Finds quoted facts for each module before its outline. A module that
        already has them keeps them.
      </FormHelperText>
    </Stack>
  );
}
